export enum CmsRequestUrls {
  translations = 'cms/ru/translations?source=pwa',
}
